import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateAdapter, MatPaginator, MatSort, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { FiltrosComprobanteElectronico } from 'app/models/FiltrosComprobanteElectronico';
import { MessagesTitles, MessagesStatus, MessagesDates, MessagesGeneral } from 'app/models/messages';
import { ReportesService } from 'app/services/reportes/reportes.service';
import moment from 'moment';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from 'environments/environment';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-lista-comprobante-electronico',
  templateUrl: './lista-comprobante-electronico.component.html',
  styleUrls: ['./lista-comprobante-electronico.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListaComprobanteElectronicoComponent{

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];

  displayedColumns = ['checked', 'Codigo_de_Valor', 'serie', 'numero', 'RUC_PROVEEDOR',
    'RAZON_PROVEEDOR', 'RUC_ADQUIRENTE', 'RAZON_ADQUIRENTE', 'Moneda', 'VNPP', 'Adelanto_porcentaje',
    'Plazo', 'CantidadContratos', 'Adelanto_Importe', 'Adelanto_Ejecutado', 'Tasa_Mensual',
    'Interes_importe', 'Comision_importe', 'IGV_importe', 'Fecha_real_desembolso', 'Fecha_de_Pago'
    , 'SERIE_IF', 'NUMERO_ID', 'VALOR_VENTA_SIN_IGV_IF'];

  abrirDetalleComprobante: boolean = false;
  loading: boolean;
  dataSource: any;
  idProvedor: any;
  idAdquirente: any;
  proveedoresArr: any;
  adquirentesArr: any;
  docNegociables: any = [];
  ruc = new FormControl();
  rucAdq = new FormControl();
  filteredProveeedor: Observable<any[]>;
  filteredAdquirente: Observable<any[]>;
  fechaD: Date = new Date();
  fechaH: Date = new Date();

  DTOFiltrosCompElec: FiltrosComprobanteElectronico = new FiltrosComprobanteElectronico();
  today = moment();
  constructor(private reporteService: ReportesService,
    private datePipe: DatePipe,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus) {
    this.fechaD.setDate(this.fechaD.getDate() - 60);
    this.ObtenerProveedoresCombo();
    this.ObtenerAdquirentesCombo();
  }

  filtradoCompElectronicos() {
    this.loading = true;

    if (this.ruc.value == null || this.ruc.value == "") {
      this.idProvedor = "0";
      this.DTOFiltrosCompElec.IdProv = "0";
    }
    if (this.rucAdq.value == null || this.rucAdq.value == "") {
      this.idAdquirente = "0";
      this.DTOFiltrosCompElec.IdAdqui = "0";
    } 

    this.reporteService.FiltrarListadoCompPago(this.DTOFiltrosCompElec, this.datePipe.transform(this.fechaD, 'yyyyMMdd'), this.datePipe.transform(this.fechaH, 'yyyMMdd'))
      .subscribe(resp => {
        this.docNegociables = resp
        this.dataSource = new MatTableDataSource(this.docNegociables);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;

      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA COMP. PAGO NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })

  }

  tipoMoneda(event) {
    if(event==''){
      this.DTOFiltrosCompElec.pMoneda=0;
    }else{ 
      this.DTOFiltrosCompElec.pMoneda = event;
    }  
  }

  obtenerRucRazSocialAdq(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.adquirentesArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idAdquirente = p.idEmpresa;
          this.DTOFiltrosCompElec.IdAdqui = p.idEmpresa;
        }
      }
    }
  }

  obtenerRucRazSocialProv(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.proveedoresArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idProvedor = p.idEmpresa;
          this.DTOFiltrosCompElec.IdProv = p.idEmpresa;
        }
      }
    }
  }


  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirente = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAdq(state) : this.adquirentesArr.slice()
        )
      );
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerIdProv(termino: string) {
    this.idProvedor = termino;
    this.DTOFiltrosCompElec.IdProv = termino;
  }


  obtenerIdAdq(termino: string) {
    this.idAdquirente = termino;
    this.DTOFiltrosCompElec.IdAdqui = termino;
  }

  AbrirDetalleComprobante(element: any) {
    this.reporteService.idDesembolso = element;
    this.abrirDetalleComprobante = true;

  }

  CerrarPopUpDetalleComprobante() {
    this.abrirDetalleComprobante = false;
  }

}
